import { Pipe, PipeTransform } from '@angular/core';
import { APPLICATION_STAGE } from '@app/config/application-stage.enum';

@Pipe({
  name: 'applicationStageName'
})
export class ApplicationStageNamePipe implements PipeTransform {

  transform(value: number): unknown {

    const element = APPLICATION_STAGE.find(e => e.id === value);

    if (element)
      return element.text;

    return '';
  }
}
